<template lang="pug">
.page
  h1 Contact
  .contact-form
    div
      RomatchInput(label="Naam *" v-model="contact.name" @blur="$v.contact.name.$touch()" :disabled="sending")
      .validation-error(v-show="$v.contact.name.$error") Dit veld is vereist
    div
      RomatchInput(label="E-mailadres *" v-model="contact.email" @blur="$v.contact.email.$touch()" :disabled="sending")
      .validation-error(v-show="$v.contact.email.$error") Dit veld is vereist
    div
      RomatchInput(label="Telefoonnummer" v-model="contact.phoneNumber" :disabled="sending")
    div
      RomatchTextarea(label="Bericht *" v-model="contact.message" @blur="$v.contact.message.$touch()" :disabled="sending")
      .validation-error(v-show="$v.contact.message.$error") Dit veld is vereist
    div
      RomatchButton(@click="send" :disabled="$v.$invalid || sending") Versturen
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import ContactService from '@/services/ContactService.js'

export default {
  data() {
    return {
      contact: {
        name: null,
        email: null,
        phoneNumber: null,
        message: null,
      },
      sending: false,
    }
  },
  validations: {
    contact: {
      name: { required },
      email: { required, email },
      message: { required },
    },
  },
  methods: {
    async send() {
      this.sending = true
      try {
        await ContactService.sendContactForm(this.contact)
        this.$alert(
          'Bedankt voor het insturen van het contact formulier. We zullen zo spoedig mogelijk antwoord geven.'
        )
      } catch (e) {
        console.error(e)
        this.$alert(
          'Er ging iets mis. Probeer later opnieuw of stuur een email naar: info@rondagroep.nl'
        )
      }
      this.sending = false
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

h1
  font-family 'Cinzel', serif
  margin-bottom 2rem
  text-align left

.page
  text-align

.contact-form
  max-width Romatch-max-width
  background-color #f8f8f8
  box-shadow 0 2px 2px 0 rgba(127, 127, 127, 127)
  box-sizing border-box
  margin auto
  display grid
  grid-template-columns 1fr
  grid-gap 1.5rem
  padding 2rem

  @media only screen and (min-width: small)
    padding 4rem 6rem
</style>
